import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ChoosePath from "@/components/sections/ChoosePath";
import Sectors from "@/components/sections/Sectors";
import { CapitalSupports, Evaluate, Principles } from "@/components/sections/Principles";
import { CapitalPathways, GrowthEngine, Process } from "@/components/sections/BuildScale";
import FitChecker from "@/components/sections/FitChecker";
import Manifesto from "@/components/sections/Manifesto";
import InvestmentAccess from "@/components/sections/InvestmentAccess";
import Partners from "@/components/sections/Partners";
import { WhyFundAI, VenturePipeline, About, FAQ, Contact, FinalCTA } from "@/components/sections/Closing";
import Disclosures from "@/components/Disclosures";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

export default function Landing() {
  return (
    <div className="relative">
      <Header />
      <main>
        <Hero />
        <div id="founders"><ChoosePath /></div>
        <Sectors />
        <CapitalSupports />
        <GrowthEngine />
        <FitChecker />
        <Evaluate />
        <CapitalPathways />
        <Process />
        <Principles />
        <Manifesto />
        <WhyFundAI />
        <InvestmentAccess />
        <Partners />
        <VenturePipeline />
        <About />
        <FAQ />
        <Contact />
        <FinalCTA />
        <Disclosures />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
